'use strict';exports.__esModule = true;var _react = require('react');var _react2 = _interopRequireDefault(_react);
var _propTypes = require('prop-types');var _propTypes2 = _interopRequireDefault(_propTypes);
var _uniqueId = require('lodash/uniqueId');var _uniqueId2 = _interopRequireDefault(_uniqueId);
var _components = require('../../../components');function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}

var BalconiesTooltip = function BalconiesTooltip() {var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},translate = _ref.translate,balconies = _ref.balconies;
  var balconyTranslate = translate('propertyDetails', 'details', 'balconiesTooltip');

  return (
    _react2.default.createElement(_components.BottomTooltip, {
        closeOnClickOutside: true,
        className: 'balconiesTooltip',
        icon: _react2.default.createElement('span', { className: 'icon icon-about' }),
        showOnHover: true },

      balconies.map(function (balcony, index) {return (
          _react2.default.createElement('div', { key: (0, _uniqueId2.default)() },
            balconyTranslate('balcony') + '\n          ' + (
            index + 1) + ': ' + balcony + '\n          ' +
            balconyTranslate('square')));})));



};

BalconiesTooltip.propTypes = {
  balconies: _propTypes2.default.array.isRequired,
  translate: _propTypes2.default.func.isRequired };exports.default =


BalconiesTooltip;module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/PropertyDetailedInfo/BalconiesTooltip/BalconiesTooltip.js
// module id = 2809
// module chunks = 0